import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const services = [{
  title: "Medical Interpretation",
  description: "Ensure accurate and empathetic communication in healthcare settings. Our interpreters are strictly HIPAA-compliant, providing reliable support for patients and medical professionals alike."
}, {
  title: "Legal Interpretation",
  description: "Precise and confidential interpretation for depositions, hearings, and client meetings. We uphold the highest standards of accuracy and reliability required in the legal field."
}, {
  title: "Document Translation",
  description: "Rigorous translation services for medical, legal, and academic documents. We guarantee meticulous attention to detail and cultural nuance for all your critical paperwork."
}];
export default function ServicesGrid() {
  return <section id="services-grid" className="bg-background py-20 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-5xl">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-8">
            {services.map((service, i) => <Card key={i} data-index={i} className="flex h-full flex-col border-border/60 bg-card shadow-sm transition-shadow hover:shadow-md">
                <CardHeader className="pb-2 pt-5 sm:px-5">
                  <CardTitle className="font-serif text-2xl text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow sm:px-5">
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter className="pb-5 sm:px-5">
                  <Button variant="outline" asChild>
                    <Link to="/ConnectPage">
                      Request a Quote
                    </Link>
                  </Button>
                </CardFooter>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}